const visuallyHidden = {
  //visibility: 'hidden',
  opacity: 0,
};

export default visuallyHidden;
